import Helpers from "@utils/Helpers";
import { IGalleryListType } from "@utils/Interfaces";
import { errorLog } from "logging";
import { createContext, ReactNode, useContext, useState } from "react";
import { GalleryApi } from "services/GalleryApi";

interface GalleryContextType {
  gallery: IGalleryListType;
  updateGallery: (gallery: IGalleryListType) => void;
  fetchtGallery: () => void;
}

const GalleryContext = createContext<GalleryContextType | undefined>(undefined);

export const GalleryProvider = ({ children }: { children: ReactNode }) => {
  const [gallery, setGallery] = useState<IGalleryListType>(
    Helpers.getGallery()
  );

  const updateGallery = (allGallery: IGalleryListType) => {
    Helpers.storeGallery(allGallery);
    setGallery(allGallery);
  };

  const fetchtGallery = async () => {
    try {
      const response = await GalleryApi.getMedia();
      const gallerySummary =
        Object.keys(response.data).length === 0
          ? {
              profile: [],
              banner: [],
              product: [],
              h2u: [],
              video: [],
            }
          : response.data;
      updateGallery(gallerySummary);
    } catch (error) {
      errorLog("GalleryContext.tsx - fetchtGallery", error);
      throw new Error("Fail to fetch gallery");
    }
  };

  return (
    <GalleryContext.Provider value={{ gallery, updateGallery, fetchtGallery }}>
      {children}
    </GalleryContext.Provider>
  );
};

export const useGallery = () => {
  const context = useContext(GalleryContext);
  if (context === undefined) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};
